import { BACKEND_DOMAIN } from "./api";
import { NO_IMAGE } from "./constants";

export const getUrlImage = (path) => {
    if(path === "" || path === null) {
        return NO_IMAGE;
    }

    return `${BACKEND_DOMAIN}${path}`;
}

export const clearOrderData = () => {
    localStorage.removeItem("salesReceipt");
    localStorage.removeItem("tipoComprobante");
    sessionStorage.removeItem('pedido');
    sessionStorage.removeItem('nombrePedido');
    localStorage.removeItem("tipoPedido");
}

export function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

